"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _commonReact = require("@devsta/common-react");

var _ShotActions = _interopRequireDefault(require("../../../contexts/ShotActions"));

var _DroppableShotsArea = _interopRequireDefault(require("../components/DroppableShotsArea"));

function DroppableShotsArea(_ref) {
  var shots = _ref.shots,
      aspectRatio = _ref.aspectRatio,
      organisationId = _ref.organisationId,
      selectedShotIndex = _ref.selectedShotIndex,
      storyboardPermissions = _ref.storyboardPermissions,
      hasUpdatePermission = _ref.hasUpdatePermission;
  return _react.default.createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "droppable",
    direction: "horizontal"
  }, function (providedDroppable) {
    return _react.default.createElement(_ShotActions.default.Consumer, null, function (_ref2) {
      var createShot = _ref2.createShot,
          updateShot = _ref2.updateShot,
          updateShotAssets = _ref2.updateShotAssets;
      return _react.default.createElement(_commonReact.UploaderConsumer, null, function (_ref3) {
        var addFileToQueue = _ref3.addFileToQueue;
        return _react.default.createElement("div", (0, _extends2.default)({
          ref: providedDroppable.innerRef
        }, providedDroppable.droppableProps, {
          className: "shot-list__scroll-box",
          style: {
            minWidth: "".concat(320 * shots.length, "px")
          }
        }), _react.default.createElement(_DroppableShotsArea.default, {
          shots: shots,
          aspectRatio: aspectRatio,
          organisationId: organisationId,
          selectedShotIndex: selectedShotIndex,
          createShot: createShot,
          updateShot: updateShot,
          updateShotAssets: updateShotAssets,
          storyboardPermissions: storyboardPermissions,
          hasUpdatePermission: hasUpdatePermission,
          addFileToQueue: addFileToQueue
        }));
      });
    });
  });
}

var _default = (0, _react.memo)(DroppableShotsArea);

exports.default = _default;